import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { getStorageData, setStorageData } from "../../../framework/src/Utilities";

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  onSuccess: (data?: any) => void;
  onClose: () => void;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  stepOne: boolean;
  stepTwo: boolean;
  stepThree: boolean;
  stepFour: boolean;
  stepFive: boolean;
  isLoading: boolean;
  userName: string;
  userPhoneNumber: string;
  phoneNumberError: boolean;
  thoughts: string;
  otp: string[];
  themeSwitch: boolean;
  isKeyboardOpen: boolean;
  initialHeight: number;
  isMobile: boolean;
  error: string;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class GuestSignupController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  sendOtpToUserAPI: any = "";
  verifyOtpAPI: any = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage)
    ];

    this.state = {
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepFive: false,
      isLoading: false,
      userName: "",
      userPhoneNumber: "",
      phoneNumberError: false,
      thoughts: "",
      otp: ["", "", "", "", "", ""],
      themeSwitch:
        localStorage.getItem("yellowTheme") === "true" ? true : false,
      isKeyboardOpen: false,
      initialHeight: window.innerHeight,
      isMobile: window.innerWidth <= 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      error: ""
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.sendOtpToUserAPI) {
        if (responseJson && responseJson.data) {
          this.setState({ isLoading: false, stepThree: false, stepFour: true });
          window.localStorage.setItem(
            "EndUserAuthToken",
            responseJson.meta.token
          );
        } else if (responseJson && responseJson.errors) {
          this.setState({ isLoading: false, phoneNumberError: true });
        }
      }

      if (apiRequestCallId === this.verifyOtpAPI) {
        if (responseJson && responseJson.data) {
          this.setState({ isLoading: false, stepFour: false, stepFive: true });
        } else {
          this.setState({ isLoading: false, error: "Invalid OTP. Please try again." });
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleFocus = () => {
    if (this.state.isMobile) {
      this.setState({ isKeyboardOpen: true });
    }
  };

  handleBlur = () => {
    if (this.state.isMobile) {
      this.setState({ isKeyboardOpen: false });
    }
  };

  getOuterCountryLabel = (code: string) => {
    const country = configJSON.countryCodes?.find(
      (countryCodeData: any) => countryCodeData.code === code
    );
    return country ? country.value : "+1";
  }

  handleKeyPress = (event: React.KeyboardEvent) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  redirectToFirstPage = () => {
    this.setState({ stepOne: true, stepTwo: false, stepThree: false })
  }

  redirectToSecondPage = () => {
    this.setState({ stepOne: false, stepTwo: true, stepThree: false })
  }

  redirectToThirdPage = () => {
    this.setState({ stepOne: false, stepTwo: false, stepThree: true, stepFour: false })
  }

  handleThoughtSubmit = async (values: { thoughts: string }) => {
    this.setState({
      thoughts: values.thoughts,
      stepTwo: true,
      stepOne: false
    });
  }

  handleNameSubmit = async (values: { userName: string }) => {
    this.setState({
      userName: values.userName,
      stepThree: true,
      stepTwo: false
    });
  }

  handleOtpChange = (value: string, index: number) => {
    const newOtp = [...this.state.otp];
    newOtp[index] = value;
    this.setState({ otp: newOtp });
  };

  handelThemeChange = (e: any) => {
    this.setState({ themeSwitch: e.target.checked });
    localStorage.setItem("yellowTheme", e.target.checked);
  };

  async senOtpToUser(values: {
    code: string,
    phoneNumber: string
  }) {
    const { code, phoneNumber } = values
    const countryCode = this.getOuterCountryLabel(code)
    const fullNumber = `${countryCode}${phoneNumber}`

    this.setState({
      isLoading: true,
      userPhoneNumber: fullNumber,
      phoneNumberError: false,
    });
    const data = {
      attributes: {
        full_phone_number: fullNumber,
      },
    };

    const httpBody = {
      data: data,
    };

    const headerData = {
      "Content-Type": configJSON.exampleApiContentType,
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.sendOtpToUserAPI = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.sendOtpToEndUserEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  async verifyOtp() {
    this.setState({ isLoading: true, error: "" });
    const fullOtp = this.state.otp.join("");
    const headerData = {
      "Content-Type": configJSON.exampleApiContentType,
      "token": window.localStorage.getItem("EndUserAuthToken")
    };
    const httpBody = {
      data: {
        otp: fullOtp
      }
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.verifyOtpAPI = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.verifyUserOtpEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  createPost = () => {
    // Logic to create post and then call onSuccess
    this.props.onSuccess({
      userName: this.state.userName,
      thoughts: this.state.thoughts
    });
  }
  // Customizable Area End

}
